import Vue from "vue";

import _ from "lodash";
import cf from "@/helpers/conf";
import fn from "@/helpers/func";
import inViewportDirective from "vue-in-viewport-directive";
import VueAwesomeSwiper from "vue-awesome-swiper";
import VueKinesis from "vue-kinesis";
import Parallax from "vue-parallaxy";
import Element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import SlideUpDown from "vue-slide-up-down";
import JsonExcel from "vue-json-excel";
import * as VueGoogleMaps from "vue2-google-maps";
import Swiper, {
  Navigation,
  Pagination,
  Autoplay,
  Mousewheel,
  Scrollbar,
  Thumbs,
  Controller,
  EffectFade
} from "swiper";
import "swiper/swiper-bundle.css";
import VueMeta from "vue-meta";

Vue.use(VueAwesomeSwiper);
Vue.use(Parallax);
Vue.use(Element);
Vue.component("downloadExcel", JsonExcel);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAnRzIEnsUtT40sSJtSg6dSqa5ueV10ghU",
    libraries: "places" // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  }

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  // installComponents: true,
});
Vue.component("slide-up-down", SlideUpDown);

Swiper.use([
  Navigation,
  Pagination,
  Autoplay,
  Mousewheel,
  Scrollbar,
  Thumbs,
  Controller,
  EffectFade
]);
Vue.use(require("vue-moment"), {
  moment
});
Vue.use(VueKinesis);
var moment = require("moment");
// require("moment/locale/es.js");
Vue.directive("in-viewport", inViewportDirective);

Vue.prototype.$fn = fn;
Vue.prototype.$cf = cf;

Vue.use(_);
Vue.prototype._ = _;

Vue.use(VueMeta);
